import moment from "moment";

export const DATE_FORMAT_WITH_MILLISECONDS = "YYYY-MM-DDTHH:mm:ss.SSSZZ";

export function useDefaultDateFormat(date) {
  return moment(date).format(DATE_FORMAT_WITH_MILLISECONDS);
}
